import { render, staticRenderFns } from "./BtnServicePlan.vue?vue&type=template&id=3013309a"
import script from "./BtnServicePlan.vue?vue&type=script&lang=js"
export * from "./BtnServicePlan.vue?vue&type=script&lang=js"
import style0 from "./BtnServicePlan.vue?vue&type=style&index=0&id=3013309a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports